import React, { Component } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field as FormikField } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import { toast } from "react-toastify";

import { toggleStep } from "../../../../store/actions/multiplos-actions";
import Field from "../../field";
import StyledButton from "../../button";
import api from "../../../../services/api";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  FieldsContainer,
  Fields,
  ButtonContainer
} from "../styles";

class SmsValidation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      token: null
    };
  }

  async componentDidMount() {
    this.sendSmsToken();
  }

  sendSmsToken = () => {
    this.setState({ loading: true });
    const { userId, contactId, contact, customerCode, document } = this.props;
    const header = {
      "Content-Type": "application/json"
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      tokenType: "ADD_CONTACT",
      contactId: contactId,
      customerCode: customerCode,
      document: document
    };
    api
      .post(`industrial/customer/v1/users/${userId}/tokens`, body, parameters)
      .then(res => {
        this.setState({ loading: false });
        toast.success(`Um código de SMS foi enviado para ${contact}`);
      })
      .catch(err => {
        this.setState({ loading: false });
        if (err.response.data.message) {
          toast.error(err.response);
        } else {
          toast.error(
            "Não foi possível realizar a operação, tente novamente mais tarde"
          );
        }
      });
  };

  requestValidationSms = values => {
    this.setState({ loading: true });
    const { token } = values;
    const { userId, document, customerCode } = this.props;
    const userEmail = localStorage.getItem("@UltragazEmpresarial:loginEmail");
    const header = {
      "Content-Type": "application/json"
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      contact: userEmail,
      contactType: "EMAIL",
      token: token,
      customerCode: customerCode,
      document: document
    };
    api
      .post(`industrial/customer/v1/users/${userId}/contacts`, body, parameters)
      .then(res => {
        if (res.status === 201) {
          this.requestRegisterContract();
        } else {
          this.setState({ loading: false });
          toast.error("Não foi possível realizar a operação, tente novamente!");
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        toast.error(err.response);
      });
  };

  requestRegisterContract = () => {
    const { userId, customerCode, document } = this.props;
    const access_token = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    const header = {
      "Content-Type": "application/json",
      access_token
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      customerCode: customerCode,
      document: document
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/customers`,
        body,
        parameters
      )
      .then(res => {
        if (res.status === 201) {
          this.props.dispatch(toggleStep(5));
        }
      })
      .catch(err => {
        if (err.response.data.code === "422.014") {
          this.props.dispatch(toggleStep(2));
        } else {
          this.setState({ loading: false });
          const message = err.response.data.message;
          if (message) {
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  };

  validationSchema = () =>
    Yup.object().shape({
      token: Yup.number("O token é composto somente por números").required(
        "Insira um código"
      )
    });

  render() {
    const { close, back } = this.props;
    return (
      <Formik
        initialValues={{
          token: ""
        }}
        onSubmit={values => {
          this.requestValidationSms(values);
        }}
        validationSchema={this.validationSchema}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <Container>
            <Header>
              <Left>
                {back ? (
                  <BackButton
                    title="Fechar"
                    className="mdi mdi-arrow-left"
                    onClick={() => this.props.dispatch(toggleStep(2))}
                  />
                ) : null}
                <Title>Vincular Novo Contrato</Title>
              </Left>
              <CloseIcon
                title="Fechar"
                className="mdi mdi-close"
                onClick={close}
              />
            </Header>
            <Content>
              Enviamos um código de verificação por SMS para validação do número
              informado:
            </Content>
            <FieldsContainer>
              <Fields>
                <Form>
                  <BootstrapForm.Group controlId="token">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <Field
                            {...field}
                            type="text"
                            label="Código de verificação"
                            ariaLabel="Código de verificação"
                            ariaRequired
                            errorCondition={errors.token && touched.token}
                            errorMessage={errors.token}
                            title="Código de verificação"
                            onBlur={handleBlur}
                            placeholder="Código de verificação"
                            value={values.token}
                            onChange={handleChange}
                          />
                        );
                      }}
                      name="token"
                    />
                  </BootstrapForm.Group>
                  <ButtonContainer>
                    <StyledButton
                      className="mt-4"
                      outline
                      icon="cellphone"
                      text="Reenviar Código SMS"
                      loading={this.state.loading}
                      color="#F0B01B"
                      onClick={() => this.sendSmsToken()}
                    />
                  </ButtonContainer>
                  <ButtonContainer>
                    <StyledButton
                      type="submit"
                      icon="account-plus"
                      text="Confirmar"
                      loading={this.state.loading}
                      color="#F0B01B"
                    />
                  </ButtonContainer>
                </Form>
              </Fields>
            </FieldsContainer>
          </Container>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  userId: state.multiplosReducer.userId,
  customerCode: state.multiplosReducer.user,
  document: state.multiplosReducer.document,
  contactId: state.multiplosReducer.contactId,
  contact: state.multiplosReducer.contact
});

export default connect(mapStateToProps)(SmsValidation);
